export default __webpack_public_path__ + "static/media/jail.0b5f8de0.png";